import { render, staticRenderFns } from "./AktarilanDosyaDetay.vue?vue&type=template&id=5ce5bf22&scoped=true"
import script from "./AktarilanDosyaDetay.vue?vue&type=script&lang=ts"
export * from "./AktarilanDosyaDetay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5bf22",
  null
  
)

export default component.exports